module.exports = __webpack_public_path__ + "static/media/logo.92dfc34f.svg";